import type { Product } from '@/types/product'

export function setTouched(value: boolean): Record<keyof Product, boolean> {
  return {
    uuid: value,
    id: value,
    aantalVerpakkingen: value,
    chemischeSamenstelling: value,
    createdDate: value,
    eenheid: value,
    euralCode: value,
    euralBeschrijving: value,
    euralGevaarlijk: value,
    extraOptions: value,
    fysischeEigenschappen: value,
    gewicht: value,
    naam: value,
    omschrijving: value,
    rdCode: value,
    statischNummer: value,
    verpakkingType: value,
  }
}
